module.exports = __webpack_public_path__ + "static/media/cupertron.50a0e83e.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pimiento/climasense/xanthomonas_pimiento/preventiva/cupertron.png
// module id = 2211
// module chunks = 3